import _regeneratorRuntime from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
var path = process.env.VUE_APP_BASE_API;
import { getFileList } from "@/api/fileUploadAndDownload";
export default {
  props: {
    target: [Object],
    targetKey: [String]
  },
  data: function data() {
    return {
      drawer: false,
      picList: [],
      path: path
    };
  },
  methods: {
    chooseImg: function chooseImg(url, target, targetKey) {
      if (target && targetKey) {
        target[targetKey] = url;
      }
      this.$emit("enter-img", url);
      this.drawer = false;
    },
    open: function open() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return getFileList({
                page: 1,
                pageSize: 9999
              });
            case 2:
              res = _context.sent;
              _this.picList = res.data.list;
              _this.drawer = true;
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    }
  }
};